export const TOKEN_KEY = 'safe_display_access_token'
export const GUNS_TOKEN_KEY = 'safe_display_guns_token'
export const USER_KEY = 'safe_display_user'

export function getToken () {
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY) || ''
}

export function setToken (token, remember = true) {
  localStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(TOKEN_KEY)
  if (!token) return
  if (remember) {
    localStorage.setItem(TOKEN_KEY, token)
  } else {
    sessionStorage.setItem(TOKEN_KEY, token)
  }
}

export function clearToken () {
  localStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(TOKEN_KEY)
}

export function getUser () {
  try {
    const raw = localStorage.getItem(USER_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export function setUser (user) {
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
  } else {
    localStorage.removeItem(USER_KEY)
  }
}

export function clearUser () {
  localStorage.removeItem(USER_KEY)
}

export function getGunsToken () {
  return localStorage.getItem(GUNS_TOKEN_KEY) || sessionStorage.getItem(GUNS_TOKEN_KEY) || ''
}

export function setGunsToken (token, remember = true) {
  localStorage.removeItem(GUNS_TOKEN_KEY)
  sessionStorage.removeItem(GUNS_TOKEN_KEY)
  if (!token) return
  if (remember) {
    localStorage.setItem(GUNS_TOKEN_KEY, token)
  } else {
    sessionStorage.setItem(GUNS_TOKEN_KEY, token)
  }
}

export function clearGunsToken () {
  localStorage.removeItem(GUNS_TOKEN_KEY)
  sessionStorage.removeItem(GUNS_TOKEN_KEY)
}

export function clearAuth () {
  clearToken()
  clearGunsToken()
  clearUser()
}
